module.exports = __webpack_public_path__ + "static/media/Chapter-image-2.8f459427.png";